import { Icon } from "@react-pdf-viewer/core";
import IconDesktop from "./IconDesktop";


function IconsLeft({ onClick, admin }) {

    return (
        <div className={"icons-left"}>

            {
                admin &&
                <>
                    <IconDesktop p={'grop'} onClick={() => onClick('projectAdmin')} />
                    <IconDesktop p={'SumA'} onClick={() => onClick('aufaSumData')} />
                    <IconDesktop p={'offices'} onClick={() => onClick('OfficeANdWorker')} />
                    <IconDesktop p={'Aufa'} onClick={() => onClick('aufaOrders')}></IconDesktop>
                </>
            }
            <IconDesktop p={"seetings"} onClick={() => onClick("seetings")} />
            <IconDesktop onClick={() => onClick("")} />
            <IconDesktop onClick={() => onClick("")} />
        </div>
    )
}


export default IconsLeft;